var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "sign-modal",
      attrs: {
        title: "",
        visible: _vm.show,
        "close-on-click-modal": false,
        width: "600px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: _vm.onChange,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(_vm._s(_vm.$t("shop-site::emailSign::title"))),
      ]),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "formSign",
          staticClass: "email-body",
          attrs: {
            model: _vm.params,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "div",
            { staticClass: "sec-box no-bg" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("shop-site::emailSign::form_email") + "：",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.params.outServer) + " ")]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("shop-site::emailSign::form_turn") + "：",
                    prop: "signatureStatus",
                  },
                },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-color": "#13ce66",
                      "inactive-color": "#ff4949",
                    },
                    model: {
                      value: _vm.params.signatureStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.params, "signatureStatus", $$v)
                      },
                      expression: "params.signatureStatus",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "label-line",
                  attrs: {
                    label: _vm.$t("shop-site::emailSign::form_content") + "：",
                    prop: "signature",
                  },
                },
                [
                  _c("RichEditor", {
                    attrs: {
                      placeholder: _vm.$t(
                        "shop-site::emailSign::placeholder_content"
                      ),
                    },
                    model: {
                      value: _vm.params.signature,
                      callback: function ($$v) {
                        _vm.$set(_vm.params, "signature", $$v)
                      },
                      expression: "params.signature",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onChange } }, [
            _vm._v(_vm._s(_vm.$t("system::common::btn::cancel"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saveLoading },
              on: { click: _vm.onSave },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }